import React from "react";
import {IUserStore, UserStore} from "../../administration/stores/userStore";
import {ITimetableStore, TimetableStore} from "../../timetables/stores/timetableStore";
import {CompanyStore, ICompanyStore} from "../../dictionaries/stores/companyStore";
import {ITicketStore, TicketStore} from "../../transportation/stores/ticketStore";
import {IPaginationStore, PaginationStore} from "./paginationStore";
import {ITcrStore, TcrStore} from "../../transportation/stores/tcrStore";
import {IOrderStore, OrderStore} from "../../transportation/stores/orderStore";
import {IPriceStore, PriceStore} from "../../priceList/stores/priceStore";

export interface IStores {
    userStore: IUserStore,
    timetableStore: ITimetableStore,
    companyStore: ICompanyStore,
    ticketStore: ITicketStore,
    orderStore: IOrderStore,
    paginationStore: IPaginationStore,
    tcrStore: ITcrStore,
    priceStore: IPriceStore
}

export const storesContext = React.createContext<IStores>({
    userStore: new UserStore(),
    timetableStore: new TimetableStore(),
    companyStore: new CompanyStore(),
    ticketStore: new TicketStore(),
    orderStore: new OrderStore(),
    paginationStore: new PaginationStore(),
    tcrStore: new TcrStore(),
    priceStore: new PriceStore()
});
